import {getApprovalStatusName} from "./approvalConstants";

export const signInModel = ({
    email,
    password,
}: Record<string, any> = {}) => ({
    email,
    password,
});

export const userModel = ({
    userId,
    firstName,
    middleName,
    lastName,
    fullName,
    districtId,
    districtName,
    email,
    password,
    confirmPassword,
    isActive,
    createDate,
    updatePasswordToken,
    updatePasswordExpiration,
    patronRole,
    patronRoleName,
    patronSubType,
    patronSubTypeName,
    charterType,
    organization,
    approvalStatus,
    roleId,
    preferredSystemTypeId,
}: Record<string, any> = {}) => ({
    userId,
    firstName: firstName || "",
    middleName: middleName || "",
    lastName: lastName || "",
    fullName: fullName || "",
    districtId: districtId,
    districtName: districtName || "",
    email: email,
    password: password,
    confirmPassword: confirmPassword,
    isActive: isActive,
    createDate: createDate || null,
    updatePasswordToken,
    updatePasswordExpiration,
    patronRole,
    patronRoleName,
    patronSubType,
    patronSubTypeName,
    charterType,
    organization,
    approvalStatus,
    approvalStatusName: getApprovalStatusName(approvalStatus),
    roleId,
    preferredSystemTypeId: preferredSystemTypeId || null,
});

